<template lang="pug">
Modal(v-show="slide" @beforexrselect="$event.preventDefault()")
  .tutorial-body(@beforexrselect="preventXrSelect($event)")
    h1 {{ __(slide.title, 'rackbuilder') }}
    DynamicMedia.help-img( v-if="slide.image" :config="{src:slide.image, width: 1398, height: 948}" )
    p(v-for="string of slide.body" v-html="__( string, 'rackbuilder' )" )
    RogueButton.tutorial-button(
      color="black"
      width="full"
      @beforexrselect="$event.preventDefault()"
      @click="goTo($event, slide.next)"
    ) {{__( slide.btnText || 'Next') }}
    Checkbox#ar-tutorial-checkbox(label="Don't show tutorial again" v-if="slide.title === 'Exit AR Mode'" v-model="dontShowAgain")
</template>
<script setup lang="ts">

import { computed, ref } from 'vue'
import { setCookie } from '@/js/services/Utils'

const props = defineProps<{ state: string }>()
const emit = defineEmits<{input: [value: string]}>()

const dontShowAgain = ref(true)

function goTo(e: Event, state = '') {
  e.preventDefault()
  if (dontShowAgain.value && state === '' && props.state === 'exit') {
    setCookie('rackbuilder_tutorial_hide', '1')
  }
  emit('input', state)
}

const slides: {[key: string] : {title: string, image: string, body: string[], next?: string, btnText?: string }} = {
  orient: {
    title : 'Capture your Environment',
    image : '/UI/rackbuilder/Environment-Detection-PNG-3x_o3w2ic.png',
    body  : ['Register the environment you want to place your rig-rack in by slowly moving your camera in a Figure-Eight. Green cubes will appear and disappear as the AR camera detects your room.'],
  },
  place: {
    title : 'Place your rig / rack',
    image : '/UI/rackbuilder/XYZ-PNG-3x_ybkdy8.png',
    body  : ['Select where you want to place your rig-rack by moving your finger across the floor. Placement location will be indicated by the X-Y axis icon in the image above.'],
    next  : 'reset',
  },
  reset: {
    title : 'Reset your Rig / Rack location',
    image : '/UI/rackbuilder/Reset_qqmlum.png',
    body  : ['To reactivate rig-rack "Placement" mode, select the enabled Cube button located at the bottom right corner of your screen.'],
    next  : 'exit',
  },
  exit: {
    title   : 'Exit AR Mode',
    image   : '/UI/rackbuilder/Return_owq2ou.png',
    body    : ['To return to the product page, select the "Return" button while not in product placement mode.'],
    btnText : 'Done',
  },
  troubleshoot: {
    title : 'Troubleshooting',
    image : '',
    body  : [
      '<strong>Why isn’t my environment being detected?</strong>',
      'An environment can be difficult to detect in low-light situations. Increasing the lighting can help with calibration.',
      '<strong>Why is my rig-rack missized?</strong>',
      'Missizing can result from not having adequate open floor space where you want to place your rig-rack.',
      'However, renderings and depictions are conceptual only and are for the convenience of reference. They should not be relied upon as representations, express or implied, of the final detail of the Units.',
    ],
    btnText: 'Return',
  },
}

const slide = computed(() => slides[props.state])

function preventXrSelect(e:Event) {
  e.preventDefault()
}

</script>
<style lang="scss" scoped>
.tutorial-body {
  pointer-events: all;
}
.help-img {
  margin-bottom: $space-s;
}
.tutorial-button {
  margin-bottom: $space-s;
}
</style>
